import React from "react";
import { Link } from "react-router-dom";
import { RightHeaderComponent } from "./menu/Header";

function NavBar({
  className,
  title,
  breadcrumb,
  description,
  link,
  children,
  extra,
}) {
  return (
    <div
      className={`z-[81] w-full bg-white sticky top-0 [@media(max-width:1024px)]:border-b border-light-color ${className}`}
    >
      <div className="h-[88px] [@media(max-width:1023px)]:bg-transparent bg-pri-tint-3 flex justify-between pr-5 pl-14 lg:px-10 items-center lg:items-start">
        <div className="flex flex-col h-full justify-center">
          <h6
            className="mb-0 lg:mb-1 [@media(max-width:1024px)]:text-xl leading-8 line-clamp-1 text-ellipsis w-full"
            data-testid="calendar_title"
          >
            {title}
            {breadcrumb ? (
              <Link to={`/${link}`} className="hidden sm:inline-flex">
                <span className="pri mx-2">{">"}</span>
                <span className="pri">Back to profile</span>
              </Link>
            ) : (
              ""
            )}
          </h6>
          <p className="mb-0 p-xs hidden lg:block lg:max-w-[450px] [@media(min-width:1330px)]:max-w-[664px] line-clamp-2 text-ellipsis overflow-hidden max-h-[50px] text-[#535393] one-liner">
            {description}
          </p>
        </div>
        <div className="flex items-center h-full gap-5">
          {extra ? <div>{extra}</div> : null}
          <RightHeaderComponent />
        </div>
      </div>
      {children}
    </div>
  );
}

export default NavBar;
